import {GlobalVariables} from "../GlobalVariables";
import {ScrollTrigger} from "../LibrariesImport";

export default class ArchiveFaq {

	static init() {
		const nav = document.querySelector('.faq-nav');
		if (!nav) {
			return;
		}

		const links = nav.querySelectorAll('[data-faq-anchor]');

		const setCurrent = (slug) => {
			nav.querySelector('.item.current')?.classList.remove('current');
			const link = nav.querySelector(`[data-faq-anchor="${slug}"]`);
			if (!link) {
				return;
			}
			link.parentElement.classList.add('current');

			// Mobile : on fait défiler la barre pour garder la catégorie courante visible
			const list = link.closest('ul');
			if (list.scrollWidth > list.clientWidth) {
				list.scrollTo({left: link.offsetLeft - list.clientWidth / 2 + link.offsetWidth / 2, behavior: 'smooth'});
			}
		};

		links.forEach((link) => {
			link.addEventListener('click', (e) => {
				const target = document.getElementById(link.dataset.faqAnchor);
				if (!target || !GlobalVariables.lenis) {
					return;
				}
				e.preventDefault();
				history.replaceState(null, '', `#${link.dataset.faqAnchor}`);
				GlobalVariables.lenis.scrollTo(target, {
					offset: -parseInt(window.getComputedStyle(target).scrollMarginTop),
					duration: 1,
					easing: t => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
				});
			});
		});

		document.querySelectorAll('.faq-category').forEach((category) => {
			ScrollTrigger.create({
				trigger: category,
				start: "top center",
				end: "bottom center",
				onEnter: () => setCurrent(category.id),
				onEnterBack: () => setCurrent(category.id)
			});
		});
	}

}
